import axios, { AxiosError, AxiosResponse } from "axios";
import { environments } from "../environments";
import getMessageFromHttpStatus from "./axiosUtils";
import IResponseBody from "../../interfaces/response-body";

const api = axios.create({
  baseURL: environments.url_api,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

const noAuthApi = axios.create({
  baseURL: environments.url_api,
});

api.interceptors.response.use((response) => response, (error) => {
    if (error instanceof AxiosError) {
      if(error.code === "ERR_CANCELED") {
        return;
      }
      const errorMessage =
        getMessageFromBody(error.response) ||
        getMessageFromHttpStatus(error.response?.status) ||
        "Ocorreu um erro inesperado";
        console.log(error);

        throw new Error(errorMessage);
    }

    throw error;
  }
);

function getMessageFromBody(response: AxiosResponse<IResponseBody<any>, any> | undefined): string | undefined {
  return response?.data?.errors?.join(", ");
}

export { api, noAuthApi };
